import { type MutationError, trpc } from '@/shared/api';

interface Options {
  readonly onSuccess?: () => void;
}

/** 템플릿 삭제 — 이미 적용된 상품 편집영역에는 영향이 없다. */
export const useDeleteEditAreaTemplate = ({ onSuccess }: Options = {}) => {
  const mutation = trpc.productManagement.editAreaTemplates.delete.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return { deleteTemplate: mutation.mutate, isPending: mutation.isPending, error };
};
